import { toast } from "@grafit/design-system/components/molecules/toast";
import type { TFunction } from "@grafit/i18n";

export function assertOnline(t: TFunction): boolean {
  if (window.navigator.onLine) {
    return true;
  }
  toast.error(t((r) => r["auth.sign-in.error.offline"]));
  return false;
}
